export const dashboardRoutes = [
  {
    path: '/home',
    name: 'inicio',
    component: () => import('./Dashboard.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: [
        'admin',
        'superadmin',
        'supervisor',
        'employee',
        'admin users & supervisors',
        'RRHH',
      ],
    },
  },
]
